import { noop } from 'lodash';

const isBrowser = () => typeof window !== 'undefined';

const perf = {
  mark:
    (isBrowser() &&
      window.performance.mark &&
      window.performance.mark.bind(window.performance)) ||
    noop,
  measure:
    (isBrowser() &&
      window.performance.measure &&
      window.performance.measure.bind(window.performance)) ||
    noop,
};

export const nonProductionMeasure = (name: string, fn: Function) => (
  ...args: any[]
) => {
  perf.mark(`${name}:start`);
  const result = fn(...args);
  perf.mark(`${name}:end`);
  perf.measure(name, `${name}:start`, `${name}:end`);
  return result;
};

export const productionMeasure = (_: string, fn: Function) => fn;

export const measure =
  process.env.NODE_ENV === 'production'
    ? productionMeasure
    : nonProductionMeasure;
